<template>
  <div class="product__tabs-content tab-content">
    <keep-alive>
      <ProductDescription
        v-if="(activeTab && activeTab === 'description') || activeTab === ' ' || (activeTab && !isInTabs)"
        :statsCounters="statsCounters"
        :analytics-data="analyticsData"
      />
      <WithScrollingCard :analytics-data="analyticsData" v-else class="page-container">
        <keep-alive>
          <component
            :is="activeComponent"
          />
        </keep-alive>
      </WithScrollingCard>
    </keep-alive>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import WithScrollingCard from './WithScrollingCard'
import ProductDescription from '@/views/product-page/tabs/ProductDescription'
import ProductCharacteristics from '@/views/product-page/tabs/ProductCharacteristics'
// import ProductEquipment from '@/views/product-page/tabs/ProductEquipment'
import ProductVideos from '@/views/product-page/tabs/ProductVideos'
import ProductComments from '@/views/product-page/tabs/ProductComments'
import ProductQuestions from '@/views/product-page/tabs/ProductQuestions'
import ProductInstructionsTab from '@/views/product-page/tabs/ProductInstructionsTab'
import ProductCombinedProducts from '@/views/product-page/tabs/ProductCombinedProducts'

export default {
  name: 'ProductTabsContent',
  components: {
    ProductInstructionsTab,
    ProductCharacteristics,
    ProductDescription,
    // ProductEquipment,
    ProductVideos,
    WithScrollingCard,
    ProductComments,
    ProductCombinedProducts,
    ProductQuestions
  },
  props: {
    statsCounters: Array,
    analyticsData: {
      type: Array
    }
  },
  computed: {
    ...mapState({
      tabs: state => state.productTabs.tabs,
      activeTab: state => state.productTabs.activeTab
    }),
    isInTabs () {
      return this.tabs.includes(this.activeTab)
    },
    activeComponent () {
      if (this.activeTab) {
        switch (this.activeTab) {
          case 'characteristics':
            return ProductCharacteristics

          case 'comments':
            return ProductComments

          case 'questions':
            return ProductQuestions

          case 'videos':
            return ProductVideos

            // case 'equipment':
            //   return ProductEquipment

          case 'instructions':
            return ProductInstructionsTab

          case 'combined-products':
            return ProductCombinedProducts
        }
      }

      return ''
    }
  }
}
</script>

<style scoped lang="sass">
.product__tabs-content
  margin-top: 12px
  +mmin($tablet--hor)
    margin-top: 30px
</style>
